import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenCheck, ShieldCheck, ScrollText, Download } from 'lucide-react';

const fundamentos = [
  'Cremos na Bíblia Sagrada como a Palavra de Deus, inspirada, infalível e suficiente para orientar fé e prática.',
  'Cremos em um só Deus, eterno e soberano, revelado em três pessoas: Pai, Filho e Espírito Santo.',
  'Cremos em Jesus Cristo, Filho de Deus, em sua encarnação, morte substitutiva, ressurreição e retorno glorioso.',
  'Cremos no Espírito Santo, que convence do pecado, regenera, santifica e capacita a Igreja para cumprir sua missão.',
];

const principios = [
  'Vida de oração, santidade e dependência diária do Senhor.',
  'Centralidade da Palavra, comunhão fraterna e discipulado intencional.',
  'Amor ao próximo, serviço com excelência e compromisso com a missão da Igreja.',
  'Unidade do Corpo de Cristo, honra às lideranças e compromisso com a verdade do Evangelho.',
];

const doutrinas = [
  'Salvação pela graça, mediante a fé em Jesus Cristo, e não por obras humanas.',
  'Batismo nas águas como testemunho público de fé e nova vida em Cristo.',
  'Ceia do Senhor como memorial da aliança em Cristo e anúncio de sua volta.',
  'Ressurreição dos mortos, juízo final e vida eterna com Deus para os que crêem no Evangelho.',
];

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: { delay: index * 0.1, duration: 0.5 },
  }),
};

const DeclaracaoFe = () => {
  return (
    <div className="pt-20 bg-[#030B2E] min-h-screen">
      <section className="section-padding bg-gradient-to-br from-[#030B2E] via-[#030B2E] to-[#17E6B3]/20 text-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Declaração de Fé
            </h1>
            <p className="text-xl md:text-2xl text-[#B8C4E3]">
              Fundamentos, princípios e doutrinas que norteiam nossa caminhada cristã.
            </p>

            <motion.a
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              href="/declaracao-de-fe.pdf"
              download
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-lg bg-[#17E6B3] text-[#030B2E] font-bold hover:shadow-lg hover:shadow-[#17E6B3]/30 transition-all"
            >
              <Download size={20} />
              Baixar PDF da Declaração de Fé
            </motion.a>
          </motion.div>
        </div>
      </section>

      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom grid grid-cols-1 lg:grid-cols-3 gap-8">
          <motion.article
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={0}
            variants={cardVariants}
            className="bg-white/5 border border-[#17E6B3]/20 rounded-xl p-8"
          >
            <div className="flex items-center gap-3 mb-6">
              <BookOpenCheck className="text-[#17E6B3]" size={32} />
              <h2 className="text-2xl font-bold text-white">Fundamentos</h2>
            </div>
            <ul className="space-y-4 text-[#B8C4E3]">
              {fundamentos.map((item, index) => (
                <li key={index} className="leading-relaxed">
                  • {item}
                </li>
              ))}
            </ul>
          </motion.article>

          <motion.article
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={1}
            variants={cardVariants}
            className="bg-white/5 border border-[#17E6B3]/20 rounded-xl p-8"
          >
            <div className="flex items-center gap-3 mb-6">
              <ShieldCheck className="text-[#17E6B3]" size={32} />
              <h2 className="text-2xl font-bold text-white">Princípios</h2>
            </div>
            <ul className="space-y-4 text-[#B8C4E3]">
              {principios.map((item, index) => (
                <li key={index} className="leading-relaxed">
                  • {item}
                </li>
              ))}
            </ul>
          </motion.article>

          <motion.article
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={2}
            variants={cardVariants}
            className="bg-white/5 border border-[#17E6B3]/20 rounded-xl p-8"
          >
            <div className="flex items-center gap-3 mb-6">
              <ScrollText className="text-[#17E6B3]" size={32} />
              <h2 className="text-2xl font-bold text-white">Doutrinas</h2>
            </div>
            <ul className="space-y-4 text-[#B8C4E3]">
              {doutrinas.map((item, index) => (
                <li key={index} className="leading-relaxed">
                  • {item}
                </li>
              ))}
            </ul>
          </motion.article>
        </div>
      </section>
    </div>
  );
};

export default DeclaracaoFe;
